// extracted by mini-css-extract-plugin
module.exports = {"desktop":"Social-module--desktop--aNPAD","mobile":"Social-module--mobile--3Sz3Z"};